import React, { useEffect, useState } from 'react'
import { Modal, Button, Container } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function ConfirmWidget({
  children,
  title = 'ยืนยัน',
  confirmBtn = 'ยืนยัน',
  cancleBtn = 'ยกเลิก',
  size = 'xs',
  backdrop = 'static',
  hideConfirm,
  hideCancle,
  disabled,
  ...props
}) {
  const { show, onCancle, onConfirm, detail, selfLoadingOff } = props

  const [isSelfLoading, setIsSelfLoading] = useState(disabled)

  useEffect(() => {
    setIsSelfLoading(disabled)
  }, [disabled])

  const handleOnClick = () => {
    !selfLoadingOff && setIsSelfLoading(true)
    onConfirm()
  }

  const handleOnShow = () => {
    setIsSelfLoading(false)
  }

  return (
    <Modal backdrop={backdrop} size={size} show={show} onHide={onCancle} onShow={handleOnShow}>
      <Modal.Header>
        <Modal.Title>
          <p style={{ paddingTop: '0.5rem' }}>{title}</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}>{detail}</div>
      </Modal.Body>

      {children}

      <Modal.Footer>
        <div>
          {!hideConfirm && (
            <SaveButton
              //icon="check"
              onClick={handleOnClick}
              disabled={isSelfLoading || props.disabled}
              children={confirmBtn}
            />
          )}

          {!hideCancle && (
            <CancelButton onClick={onCancle} disabled={isSelfLoading} children={cancleBtn} />
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}
